<!-- add routing here /searchnumer -->
<template>
  <v-container class="text-center">
    <v-card
        class="resultContainer"
        elevation="3"
        shaped
        outlined
    >
      <v-list-item three-line>
        <v-list-item-content>
          <div class="text-overline mb-4">
            TRACKING
          </div>
          <div v-if="error === false">
            <v-list-item-title class="text-h5 mb-1">
              Tracking No. <em>{{ searchResult.caseId }}</em>
            </v-list-item-title>

            <horizontal-stepper v-if="!isMobileView"
                                :latest-status="latestStatus"
                                :search-result="searchResult"
                                :tracking-link="trackingLink">
            </horizontal-stepper>

            <vertical-stepper v-if="isMobileView"
                              :latest-status="latestStatus"
                              :search-result="searchResult"
                              :tracking-link="trackingLink">
            </vertical-stepper>

          </div>
          <div v-else>
            <v-alert
                dense
                outlined
                color="red"
                type="error">
              {{ errorText }}
            </v-alert>
          </div>

          <pod-dialog v-if="latestStatus === 4 && error === false && searchResult.hasDocument"
                           :case-id="searchResult.caseId"
                           :delivery-date="searchResult.trackingStates.filter(s => s.statusNummer === 4)[0].date.substring(0,10)"
                           :token="token"/>

        </v-list-item-content>
      </v-list-item>

    </v-card>

  </v-container>
</template>

<script>
import HorizontalStepper from "@/components/HorizontalStepper";
import VerticalStepper from "@/components/VerticalStepper";
import podDialog from "@/components/PodDialog";


export default {
  name: "Result",
  components: {VerticalStepper, HorizontalStepper, podDialog},
  props: {
    searchResult: {
      caseId: null,
      shipmentNumberPost: null,
      shipmentNumberDhl: null,
      shipmentType: null,
      hasDocument: null,
      trackingStates: []
    },
    error: null,
    errorText: null,
    token: null
  },
  data: () => ({
    latestStatus: null, //needed to create steps
    generic_dhlLink: "https://www.dhl.com/ch-de/home/tracking/tracking-express.html?submit=1&tracking-id=", //generic link for dhl tracking - tracking number will be appended to the end
    generic_postLink: "https://service.post.ch/ekp-web/ui/entry/search/", //generic link for post tracking - tracking number will be appended to the end
    trackingLink: "", //placeholder for the Tracking URL based on Versandart - gets defined in mounted()
    windowWidth: window.innerWidth, //width of window
    isMobileView: false //set to true if width <= 960px

  }),
  /**
   * Gets triggered when Component is initialized
   * Looks for the latest order state and sets the variable
   * Creates tracking URL based on the Versandart DHL / POST and sets the variable
   */
  mounted() {
    //if user gets to results on mobile or small device directly set window width
    this.onResize() //change results if width is <= than 960px

    // get lateststatus and trackinglink if no error was thrown (no error = response with entry)
    if (!this.error) {
      //set variable with latest status
      this.latestStatus = this.searchResult.trackingStates.slice(0).sort(
          function (x, y) {
            return y.statusNummer - x.statusNummer
          })[0].statusNummer

      this.trackingLink = this.createTrackingURL(this.searchResult.shipmentType, this.searchResult.shipmentNumberPost, this.searchResult.shipmentNumberDhl)
    }

    //add listener for detecting window resize
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })

  },

  methods: {
    /**
     * sets windowWidth and isMobileView variable based on window size
     */
    onResize() {
      this.windowWidth = window.innerWidth
      this.isMobileView = this.windowWidth >= 960 ? false : true
    },
    /**
     * Creates Tracking-URL for forwarded transports to Post or DHL on their websites
     * @param versandart
     * @param Post_sendungsNummer
     * @param DHL_sendungsNummer
     * @returns {string}
     */
    createTrackingURL(versandart, Post_sendungsNummer, DHL_sendungsNummer){
      //create tracking link based on versandart
      //if no sendungsnummer is available, the link will redirect them to the search box of the provider
      if (versandart === "DHL") {
        //create dhl link, if no sendungsnummer is available the link still works!
        return this.generic_dhlLink + DHL_sendungsNummer
      } else if (
          versandart === "POST" &&
          String(Post_sendungsNummer).length > 0 &&
          Post_sendungsNummer != null) {
        //create post link
        return this.generic_postLink + Post_sendungsNummer
      } else {
        //generic link if no sendungsnummer is available
        return "https://service.post.ch/ekp-web/ui/list"
      }
    }
  },
  /**
   * Global function
   * remove windowsize listener when components is closed/removed
   */
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },


}

</script>

<style scoped>

</style>